
import ReactGA from 'react-ga4';

let analyticsInitialized = false;

export const initAnalytics = () => {
  const measurementId = process.env.REACT_APP_GA4_MEASUREMENT_ID;
  
  if (measurementId && !analyticsInitialized) {
    ReactGA.initialize(measurementId);
    analyticsInitialized = true;
    console.log('Google Analytics initialized');
  }
};

export const trackEvent = (eventName, eventParams = {}) => {
  if (analyticsInitialized) {
    ReactGA.event({
      category: eventParams.category || 'User Interaction',
      action: eventName,
      label: eventParams.label,
      value: eventParams.value,
      ...eventParams,
    });
  }
};

export const trackPageView = (path) => {
  if (analyticsInitialized) {
    ReactGA.send({ hitType: 'pageview', page: path });
  }
};

const analytics = {
  initAnalytics,
  trackEvent,
  trackPageView,
};

export default analytics;
